import React from "react";

const BallotInfoMessage = ({ message }) => {

  return (<h4 className="text-center">{message}</h4>);

}

export default BallotInfoMessage;
